'use client';

import React from 'react';
import dynamic from 'next/dynamic';
import WhyArmeniaTemplateStyle from './style';
const HeroSection = dynamic(() => import('../components/HeroSection'), {
	ssr: true,
});
const KeyFactsSection = dynamic(() => import('../components/KeyFactsSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const TalentsSection = dynamic(() => import('../components/TalentsSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const ChartSection = dynamic(() => import('@/sections/ChartSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const EducationSection = dynamic(() => import('../components/EducationSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const ExpatSection = dynamic(() => import('@/sections/ExpatSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const WithRegionsSection = dynamic(() => import('../components/WithRegionsSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const RangeColumnChart = dynamic(() => import('@/sections/ChartSection/components/RangeColumnChart'), {
	ssr: false,
});

const WhyArmeniaTemplate = ({ pageData }) => {
	const { content } = pageData;
	const { hero, key_facts, talents, unemployment, label_force_age_group_values, educations, investment, infrastructures, chart } = content;

	const formattedUnemployment = unemployment?.items?.map(({ additional_info }, index) => {
		const { date, value } = additional_info;

		const isNegative = value < 0;

		return {
			date,
			value: isNegative ? 0 : value,
			openValue: isNegative ? value : 0,
			value2: isNegative ? value - 0.5 : value + 0.5,
			openValue2: isNegative ? value - 0.5 - 6 : value + 0.5 + 6,
			isNegative,
			id: index,
		};
	});

	const formattedLabelForceAgeGroupValues = label_force_age_group_values?.items?.map(({ additional_info }, index) => {
		const { key, value } = additional_info;

		const isNegative = value < 0;

		return {
			date: key,
			value: isNegative ? 0 : value,
			openValue: isNegative ? value : 0,
			value2: isNegative ? value - 0.5 : value + 0.5,
			openValue2: isNegative ? value - 0.5 - 6 : value + 0.5 + 6,
			isNegative,
			id: index,
		};
	});

	return (
		<WhyArmeniaTemplateStyle>
			<HeroSection {...hero} />

			<KeyFactsSection {...key_facts} />

			<WithRegionsSection
				investment={investment}
				chart={chart}
			/>

			<TalentsSection {...talents} />

			<ChartSection
				{...unemployment}
				items={formattedUnemployment}
				Chart={RangeColumnChart}
				isBlackBackgroundVersion
				className='unemployment-chart'
				colorsTheme={{ isBlackVersion: { headBgColor: '#993944', headTextColor: '#F098A2', bodyBgColor: '#800000' } }}
			/>

			<ChartSection
				{...label_force_age_group_values}
				items={formattedLabelForceAgeGroupValues}
				Chart={RangeColumnChart}
				isBlackBackgroundVersion
				colorsTheme={{ isBlackVersion: { headBgColor: '#FFA545', headTextColor: '#BA6000', bodyBgColor: '#BA6000' } }}
			/>

			<EducationSection {...educations} />

			<ExpatSection {...infrastructures} />
		</WhyArmeniaTemplateStyle>
	);
};

export default WhyArmeniaTemplate;
